import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import utils from '@/helper/utils';

export default {
  async list({ type = 'nfc', query = {} } = {}) {
    const pickedQuery = _.pick(query, ['page', 'page_size', 'q']);
    let url = `${configService.get('apiUrl')}/${type}`;
    if (pickedQuery.length) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }

    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getOne({ type = 'nfc', nfcId }) {
    return axios
      .get(`${configService.get('apiUrl')}/${type}/${nfcId}`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async postOne({ type = 'nfc', nfc } = {}) {
    return axios
      .post(`${configService.get('apiUrl')}/${type}`, nfc)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async patchOne({ type = 'nfc', nfcId, newNFC }) {
    return axios
      .patch(`${configService.get('apiUrl')}/${type}/${nfcId}`, newNFC)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async deleteOne({ type = 'nfc', nfcId }) {
    return axios
      .delete(`${configService.get('apiUrl')}/${type}/${nfcId}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  }
};
